// eslint-disable-next-line no-restricted-syntax
enum HomePageCarouselType {
  RecommendedProductsForYou = "Recommended Products For You",
  FrequentlyBoughtTogether = "Recommended Based on Cart History",
  RecentlyViewed = "Recently Viewed Products",
  BestSelling = "Best Selling Products",
}

export default HomePageCarouselType;
